import { resolveImagePath } from '@/utils/imageResolver';

interface EngineShowcaseProps {
  className?: string;
}

export function EngineShowcase({ className = '' }: EngineShowcaseProps) {
  const engineImage = resolveImagePath('/images/engine-showcase.jpg');

  return (
    <section className={`py-8 px-4 ${className}`}>
      <div className="max-w-4xl mx-auto">
        {/* Company Description */}
        <div className="text-center mb-8">
          <div className="inline-block mb-6">
            <img 
              src={resolveImagePath('/images/watson-aero-logo.png')} 
              alt="Watson Aero LLC"
              className="h-12 md:h-16 mx-auto mb-4"
              style={{ 
                marginTop: '5px',
                marginBottom: '10px',
                border: '1px solid #666666',
                padding: '3px'
              }}
            />
          </div>
          
          <div className="prose prose-lg max-w-none text-center">
            <p 
              className="text-lg leading-relaxed font-bold"
              style={{ 
                color: '#666666',
                fontFamily: 'Lato, sans-serif',
                fontSize: '19.36px'
              }}
            >
              Founded in 2015 and always located at the Louisville Municipal Airport (2J3) in the quiet town of Louisville, Georgia, just 50 miles south of Augusta, home of the Masters Tournament at the Augusta National, Watson Aero offers the finest craftsmanship in custom engine overhauls for your Lycoming or Continental powered aircraft. Click on the above links to learn more about Watson Aero!
            </p>
          </div>
        </div>

        {/* Engine Showcase Image */}
        <div className="text-center">
          <div className="inline-block">
            <img 
              src={engineImage}
              alt="Two overhauled aircraft engines on wooden pallets showcasing Watson Aero's quality craftsmanship"
              className="max-w-full h-auto rounded-lg shadow-lg"
              style={{
                border: '1px solid #d9d9d9',
                padding: '3px',
                marginBottom: '20px'
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}